<template>	   
	<v-container>
	 	<v-card>
	 	 	<v-card-title primary-title>
	 	 		<h3 class="display-1">Punto</h3>
	 	 	</v-card-title>
	 	 	<v-card-text>
	 	 		<v-text-field
	 	 		  name="search" solo
	 	 		  label="Buscar" append-icon="fa fa-search"
	 	 		  id="id"
					v-model="table.search"
	 	 		></v-text-field>
	 	 	 	<v-data-table
	 	 	 	   :headers="table.headers"
	 	 	 	   :items="table.items"
	 	 	 	   :search="table.search"
					 :loading="table.loading"
	 	 	 	   class="elevation-1" v-model="selected"
	 	 	 	   show-select
	 	 	 	   pagination.sync="pagination"
	 	 	 	   item-key="id"
	 	 	 	 >
	 	 	 	   	<template v-slot:item.actions="props">
	 	 	 	   		<td>
	 	 	 	   			<v-btn text color="warning" small fab @click="edit(props.item)"><v-icon>fa fa-pen</v-icon></v-btn>
	 	 	 	   			<v-btn text color="error" small fab @click="confirmDelete(props.item)"><v-icon>fa fa-trash</v-icon></v-btn>
	 	 	 	   		</td>
	 	 	 	   	</template>
	 	 	 	 </v-data-table> 
	 	 	</v-card-text>
	 	 	<v-card-actions>
	 	 	 	<v-btn color="success" @click="create()">Agregar nuevo Punto</v-btn> 
	 	 	</v-card-actions>
	 	</v-card>
	 	<v-dialog
	 	  v-model="modalCreate.active"
	 	  scrollable persistent
	 	  :overlay="false"
	 	  max-width="500px"
	 	  transition="dialog-transition"
	 	>
	 	  	<v-card>
	 	  	 	<v-card-title primary-title>
	 	  	 	  <h4 class="headline">Crear nuevo Punto</h4>
	 	  	 	</v-card-title>
	 	  	 	<v-card-text>
	 	  	 	 	  <v-text-field
	 	  	 	 	    name="name" required
	 	  	 	 	    label="Nombre" solo
	 	  	 	 	    v-model="modalCreate.data.name"
	 	  	 	 	  ></v-text-field>
	 	  	 	 	  <v-select
	 	  	 	 	    :items="selects.types"
	 	  	 	 	    v-model="modalCreate.data.id_type"
	 	  	 	 	    label="Categoria" solo
	 	  	 	 	    item-text="label"
	 	  	 	 	    item-value="value"
	 	  	 	 	  ></v-select>
	 	  	 	 	  <v-select
	 	  	 	 	    :items="selects.localities"
	 	  	 	 	    v-model="modalCreate.data.id_location"
	 	  	 	 	    label="Localidad" solo
	 	  	 	 	    item-text="label"
	 	  	 	 	    item-value="value"
	 	  	 	 	  ></v-select>
	 	  	 	 	  <v-text-field
	 	  	 	 	    name="name" required
	 	  	 	 	    label="Latitud" solo
	 	  	 	 	    v-model="modalCreate.data.latitude"
	 	  	 	 	  ></v-text-field>
	 	  	 	 	  <v-text-field
	 	  	 	 	    name="name" required
	 	  	 	 	    label="Longitud" solo
	 	  	 	 	    v-model="modalCreate.data.longitude"
	 	  	 	 	  ></v-text-field>
	 	  	 	 	  <v-select
								:items="selects.coor_typ"
	 	  	 	 	    name="coordinates_type" required 
	 	  	 	 	    label="Tipo de coordenadas" solo
	 	  	 	 	    v-model="modalCreate.data.coordinates_type"
	 	  	 	 	  ></v-select>
	 	  	 	</v-card-text>
	 	  	 	<v-card-actions>
	 	  	 	 	<v-btn color="secondary" @click="modalCreate.active = false">Cancelar</v-btn>
	 	  	 	 	<v-spacer></v-spacer>
	 	  	 	 	<v-btn color="primary" @click="store()">Guardar</v-btn>
	 	  	 	</v-card-actions>
	 	  	</v-card>
	 	</v-dialog>
	 	<v-dialog
	 	  v-model="modalEdit.active"
	 	  scrollable persistent
	 	  :overlay="false"
	 	  max-width="500px"
	 	  transition="dialog-transition"
	 	>
	 	  <v-card>
	 	  	 	<v-card-title primary-title>
	 	  	 	  <h4 class="headline">Editar Punto</h4>
	 	  	 	</v-card-title>
	 	  	 	<v-card-text>
	 	  	 	 	  <v-text-field
	 	  	 	 	    name="name" required
	 	  	 	 	    label="Nombre" solo
	 	  	 	 	    v-model="modalEdit.data.name"
	 	  	 	 	  ></v-text-field>
	 	  	 	 	  <v-select
	 	  	 	 	    :items="selects.types"
	 	  	 	 	    v-model="modalEdit.data.id_type"
	 	  	 	 	    label="Categoria" solo
	 	  	 	 	    item-text="label"
	 	  	 	 	    item-value="value"
	 	  	 	 	  ></v-select>
	 	  	 	 	  <v-select
	 	  	 	 	    :items="selects.localities"
	 	  	 	 	    v-model="modalEdit.data.id_location"
	 	  	 	 	    label="Localidad" solo
	 	  	 	 	    item-text="label"
	 	  	 	 	    item-value="value"
	 	  	 	 	  ></v-select>
	 	  	 	 	  <v-text-field
	 	  	 	 	    name="name" required
	 	  	 	 	    label="Latitud" solo
	 	  	 	 	    v-model="modalEdit.data.latitude"
	 	  	 	 	  ></v-text-field>
	 	  	 	 	  <v-text-field
	 	  	 	 	    name="name" required
	 	  	 	 	    label="Longitud" solo
	 	  	 	 	    v-model="modalEdit.data.longitude"
	 	  	 	 	  ></v-text-field>
	 	  	 	 	  <v-text-field
	 	  	 	 	    name="name" required 
	 	  	 	 	    label="Nombre" solo
	 	  	 	 	    v-model="modalEdit.data.coordinates_type"
	 	  	 	 	  ></v-text-field>
	 	  	 	</v-card-text>
	 	  	 	<v-card-actions>
	 	  	 	 	<v-btn color="warning" @click="modalEdit.active = false">Cancelar</v-btn>
	 	  	 	 	<v-spacer></v-spacer>
	 	  	 	 	<v-btn color="primary" @click="update()">Guardar</v-btn>
	 	  	 	</v-card-actions>
	 	  	</v-card>
	 	</v-dialog>
	 	<v-dialog
	 	  v-model="modalDelete.active"
	 	  scrollable persistent 
	 	  :overlay="false"
	 	  max-width="500px"
	 	  transition="dialog-transition"
	 	>
	 	  	<v-card>
	 	  	 	<v-card-title primary-title>
	 	  	 	  <h4 class="headline">Borrar Punto</h4>
	 	  	 	</v-card-title>
	 	  	 	<v-card-text>
	 	  	 	 	<p>¿Esta seguro de borrar este Punto?</p>
	 	  	 	</v-card-text>
	 	  	 	<v-card-actions>
	 	  	 	 	<v-btn color="secondary" @click="modalEdit.active = false">Cancelar</v-btn>
	 	  	 	 	<v-spacer></v-spacer>
	 	  	 	 	<v-btn color="primary" @click="deleteItem()">Confirmar</v-btn>
	 	  	 	</v-card-actions>
	 	  	</v-card>
	 	</v-dialog>
	 	<v-snackbar
	 	  v-model="alert.active"
	 	>
	 	 {{ alert.messague }}
	 	  <v-btn text :color="alert.color" @click.native="alert.active = false">Close</v-btn>
	 	</v-snackbar>
	</v-container>
</template>
<script>
/* eslint-disable */
	export default{
		created() {

		},
		mounted(){
			this.getData();
		},
		props: [
			'auth'
		],
		data(){
			return {
				createCategory: '',
				editCategory: '',
				baseRoute: process.env.VUE_APP_URL + 'api/gis/point',
				table: {
					items: [],
					headers: [],
					loading: true,
					search: ''
				},
				modalEdit: {
					active: false,
					data: {}
				},
				modalCreate: {
					active: false,
					data: {}
				},
				modalDelete: {
					active: false,
					data: {}
				},
				alert: {
					active: false,
					messague: "",
					color: "success"
				},
				selects: {
					types: [],
					localities: [],
					coor_typ: []
				},
				selected: []
			}
		},
		methods: {
			getData(){
				axios.get(this.baseRoute).then((res) => {
					if(res.data == "Error"){
						this.alert.active = true;
						this.alert.messague = "Impsoble traer los datos";
						this.alert.color = "error";
					}else{
						this.table.items = res.data.items;
						this.table.headers = res.data.headers;
						this.selects = res.data.selects;
					}
					this.table.loading = false
				}).catch((error) => {
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
					this.table.loading = false;
				});
			},
			create(){
				this.modalCreate.active = true;
				this.modalCreate.data = {name: ''};
			},
			store(){
				this.modalCreate.active = false;
				axios.post(this.baseRoute + '/store', this.modalCreate.data).then((res) => {
					if(res.data != "Exito"){
						this.modalCreate.data = {};
						this.alert.active = true;
						this.alert.messague = "Los datos suministrados estan incompletos o no son validos";
						this.alert.color = "error";
					}else{
						this.alert.active = true;
						this.alert.messague = "Creado exitosamente";
						this.alert.color = "success";
						this.getData();
					}
				}).catch((error) => {
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
			edit(item){
				this.modalEdit.active = true;
				this.modalEdit.data = item;
			},
			update(){
				this.modalEdit.active = false;
				axios.put(this.baseRoute + '/update', this.modalEdit.data).then((res) => {
					if(res.data != "Exito"){
						this.modalEdit.data = {};
						this.alert.active = true;
						this.alert.messague = "Los datos suministrados estan incompletos o no son validos";
						this.alert.color = "error";
					}else{
						this.alert.active = true;
						this.alert.messague = "Actualizado correctamente";
						this.alert.color = "success";					
						this.getData();

					}
				}).catch((error) => {
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
			confirmDelete(item){
				this.modalDelete.active = true;
				this.modalDelete.data = item;
			},
			deleteItem(){
				this.modalDelete.active = false;
				axios.post(this.baseRoute + '/destroy', this.modalDelete.data).then((res) => {
					if(res.data != "Exito"){
						this.modalDelete.data = {};
						this.alert.active = true;
						this.alert.messague = "Imposible de eliminar";
						this.alert.color = "error";
					}else{
						this.alert.active = true;
						this.alert.messague = "Eliminado correctamente";
						this.alert.color = "error";
						this.getData();
					}	
				}).catch((error) => {
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
		},
		watch: {

		},
		computed: {

		},
	}
/* eslint-enable */
</script>